import React from 'react';

import BuildIcon from '@mui/icons-material/Build';

import { styled, Typography, Paper } from '@mui/material';

const PREFIX = 'UnderContruction';

const classes = {
    root: `${PREFIX}-root`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        width: '100%',
        height: '100%',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: '0px',
        padding: '5px',
        backgroundColor: 'rgba(0,0,0,0)'
    }
}));

export default function UnderConstruction({title, subtitle}) {


    return (
        <Root className={classes.root}>
            <Typography variant="subtitle2" align={"center"} style={{color: 'grey'}} gutterBottom>
                <BuildIcon/>
            </Typography>
            {!title &&
            <Typography variant="subtitle2" align={"center"} style={{color: 'grey'}} gutterBottom>
                Under Construction
            </Typography>
            }
            {title &&
            <Typography variant="subtitle2" align={"center"} style={{color: 'grey'}} gutterBottom>
                {title}
            </Typography>
            }
            {title && subtitle &&
                <Typography variant="caption" align={"center"} style={{color: 'grey'}} gutterBottom>
                    {subtitle}
                </Typography>
            }
        </Root>
    );
}
